<section class="page-banner">
    <div class="hero__img">
      <img [src]="homeData?.mainImage[0]?.url" alt="Banner Image" style=" max-height: 600px;">
    </div>
    <div class="hero__caption">
      <div class="container-fluid">
        <h1></h1>
        <h1  data-aos="fade-right"
        data-aos-duration="3000" class="hero-title-ar font-bold">{{homeData?.mainTitle}}</h1>
        <p
        data-aos="fade-right"
        data-aos-duration="3000"
         class="hero-title-en m-0">{{homeData?.subTitle}}</p>
        <hr class="hero-separator">
        <!-- Conditionally show breadcrumb -->
      </div>
     <section style="
         position: fixed;
    right: 16px;
    inset-block: 0;
    height: -moz-fit-content;
    height: fit-content;
    margin: auto;
    z-index: 99;
     ">
      <ul class="list-unstyled actions-list d-flex justify-content-start p-3 ">
        <li data-aos="fade-up" class="actions-list__item" ngbTooltip="الرسالة الترحبية" placement="start"
        tooltipClass="side-bar-tooltip">
        <a class="actions-btn" (click)="showWelcome()">
          <img src="assets/images/welcome.png" alt="icon" class="shake-icon" />
        </a>
      </li>
      </ul>
     </section>
    </div>
    <marquee class=" mt-2 " direction="right" loop="infinite" style=" direction: ltr;">
        <div class="d-flex align-items-center">
          <ng-container *ngFor="let x  of marqueeData">
            <a class="p-2 m-0 text-black" style="text-decoration: none;"> {{x?.flatData?.notificationText}} </a>
            <img class="p-0 m-0" src="assets/images/arrow.png">
          </ng-container>
        </div>
    </marquee>
  </section>
  